import { createFileRoute } from '@tanstack/react-router';
import { PortalNewSuccessStep } from './-components/portal-new-steps/success-step';

export const Route = createFileRoute('/ngos/portals/$portalId_/setup/success')({
	component: PortalNewSuccessStep,
});
